// In your schema file
import * as yup from "yup";

export const schema = [
  yup.object({
    name: yup
      .string()
      .required("Please provide the role name")
      .max(50, "Role name cannot exceed 50 characters")
      .matches(/^[A-Za-z0-9 ]+$/, "Role name can only contain letters, numbers, and spaces"),

    "User Acess Type": yup
      .object()
      .test('at-least-one', 'Please select at least one access type (Web or Mobile)', function(value) {
        return value && (value.web === true || value.mobile === true);
      })
      .required("User access type is required"),

    permission: yup
      .string()
      .test('web-permission-required', 'Web permissions are required when Web access is enabled', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        if (userAccessType?.web === true) {
          return value && value.trim() !== "";
        }
        return true;
      })
      .test('web-permission-clear', 'Please clear web permissions before disabling Web access', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        // If web is unchecked but there are still permissions, show validation error
        if (userAccessType?.web === false && value && value.trim() !== "") {
          return false;
        }
        return true;
      }),

    Mobile_permission: yup
      .array()
      .nullable()
      .test('mobile-permission-required', 'Mobile permissions are required when Mobile access is enabled', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        if (userAccessType?.mobile === true) {
          return value && value.length > 0;
        }
        return true;
      })
      .test('mobile-permission-clear', 'Please clear mobile permissions before disabling Mobile access', function(value) {
        const userAccessType = this.parent?.["User Acess Type"];
        // If mobile is unchecked but there are still permissions, show validation error
        if (userAccessType?.mobile === false && value && value.length > 0) {
          return false;
        }
        return true;
      }),

    Admin_Access: yup
      .string()
      .nullable()
      .notRequired(),

    description: yup.string().max(250, "Description cannot exceed 250 characters")
  })
];
export const CreateRoleConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "name",
        label: "roleformlabels.name",
        type: "input",
        mandatory: "true"
      },
      {
        name: "User Acess Type",
        type: "checkboxmultiGroup",
        label: "Select Permissions",
        parentLabel: "User Access Media",
        mandatory: "true", // Added mandatory flag
        options: [
          { name: "web", label: "Web", value: "W" },
          { name: "mobile", label: "Mobile", value: "M" },
        ],
      },
      {
        name: "permission",
        containerId: "container_web_permission",
        label: "Web Permission",
        type: "hier_select_for_role",
        mandatory: "conditional" // Conditional based on web access
      },
      // {
      //   name: "Admin_Access",
      //   label: "User Role",
      //   type: "radio",
      //   // mandatory: "false", // Added mandatory flag
      //   options: [
      //     { label: "Admin", value: "true" },
      //     { label: "User", value: "false" },
      //   ]
      // },
      {
        name: "Mobile_permission",
        label: "Mobile Permission",
        containerId: "container_mobile_permission",
        type: "multi_select_role",
        mandatory: "conditional" // Conditional based on mobile access
      },
      // {
      //   name: "Web_access",
      //   type: "checkboxmultiGroupWeb",
      //   label: "Select Permissions",
      //   containerId: "container_web_access",
      //   parentLabel: "Web Access",
      //   options: [
      //     { name: "edit_permission", label: "Edit", value: "E" },
      //     { name: "view_permission", label: "View", value: "V" },
      //     { name: "delete_permission", label: "Delete", value: "D" },
      //   ],
      // },
      {
        name: "description",
        label: "roleformlabels.description",
        type: "text_area"
      },
      // {
      //   name: "Mobile_access",
      //   type: "checkboxmulti",
      //   containerId: "container_mobile_access",
      //   label: "mobile",
      //   parentLabel: "Mobile Access",
      //   options: [
      //     { name: "edit_permission", label: "Edit", value: "E" },
      //     { name: "view_permission", label: "View", value: "V" },
      //     { name: "delete_permission", label: "Delete", value: "D" },
      //   ],
      //   mandatory: "true",
      // },
    ]
  }
];